<template>
  <div class="wrapper">
    <side-bar
      v-loading="loadingImage"
      :logo="getLogo"
      :shortTitle="'Sistema de Gerenciamento de\nVendas'"
      title=""
      class="sideBar"
    >
      <template slot="links">
        <sidebar-item
          v-for="(group, key) in groups"
          :key="key"
          :menu="!!group.routes.length"
          :link="group"
          :class="{ 'route-mobile-rm': group.hideMobile }"
        >
          <sidebar-item
            v-for="(route, index) in group.routes"
            :key="route.name + index"
            :link="route"
          >
          </sidebar-item>
          <div v-if="group.name === 'Painéis'">
            <sidebar-item
              v-for="dashboard in dashboards"
              :key="dashboard.id"
              :link="{name: dashboard.title, path: '/dashboards/' + dashboard.id}">
            </sidebar-item>
          </div>
        </sidebar-item>
      </template>
      <template slot="links-after">
        <sidebar-item
          v-for="(route, index) in routesAfter"
          :key="route.name + index"
          :link="route"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content" style="opacity: 0.9999;">
      
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <div>
            <dashboard-header 
              v-loading="loadingImage"
              :img="getBackgroundImage"
            >
              <slot name="header"></slot>
            </dashboard-header>
            <div
              class="container-fluid"
              style="min-height: calc(100vh - 80px);"
            >
              <slot name="layout"></slot>
            </div>
          </div>
        </fade-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardHeader from "@/layouts/DashboardHeader";
import DashboardNavbar from "@/layouts/DashboardNavbar";
import DashboardContent from "@/layouts/Content";
import SidebarItem from "@/components/SidebarPlugin/SidebarItem";
import { FadeTransition } from "vue2-transitions";
import PageTitle from "@/layouts/PageTitle";

export default {
  components: {
    SidebarItem,
    DashboardHeader,
    DashboardNavbar,
    DashboardContent,
    FadeTransition,
    PageTitle,
  },
  data() {
    return {
      routesAfter: [],
      groups: [],
      dashboards: [],
      loadingImage: true,
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    initSidebarItems() {
      console.log(this.$router.options.groups);
      var groups = Object.assign({}, this.$router.options.groups);
      var routesAfter = [];

      // init group routes
      for (let group in groups) {
        groups[group].routes = [];
      }
      
      this.$router.options.routes.forEach((route) => {
        if (!route.meta || !route.meta.permissions) return;
        // Filtering hidden routes
        if (route.meta && route.meta.hideFromSidenavAdmin && this.$currentUser().is_admin) return;
        if (route.meta && route.meta.hideFromSidenav) return;
        if (route.meta && route.meta.hideFromSidenavSGV) return;

        // Filtering unpermited routes
        if (
          !route.meta.permissions.find((controller) =>
            this.$can("any", controller)
          )
        ) return;

        // Add to group routes
        if (route.meta.group) {
          groups[route.meta.group].routes.push(route);
        } else {
          routesAfter.push(route);
        }
      });

      // Filtering unpermited groups
      for (let group in groups) {
        if (!groups[group].permissions) continue;
        if (
          !groups[group].permissions.find((permission) =>
            this.$can("any", permission)
          )
        ) {
          delete groups[group];
        }
      }

      const topGroups = ["dashboards", "crop"];

      topGroups.forEach(groupName => {
        if (groups[groupName]) {
          if (!this.groups) this.groups = [];
          this.groups.push(groups[groupName]);
          delete groups[groupName];
        }
      });

      const otherGroups = Object.values(groups).filter(group => group !== undefined);
      const sortedOtherGroups = otherGroups.sort((a, b) => a.name.localeCompare(b.name));

      this.groups = (this.groups || []).concat(sortedOtherGroups);

      this.groups.forEach(group => {
        group.routes.sort((a, b) => a.name.localeCompare(b.name));
      });

      this.routesAfter = routesAfter.sort((a, b) => a.name.localeCompare(b.name));
    },
    initDashboards() {
      this.$http.secured
        .get('/api/v1/dashboards')
        .then(response => this.dashboards = response.data)
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    },
    getBackgroundImage() {
      if (this.loadingImage) return '';
      
      return this.setting_image && this.setting_image.background_sgv && this.setting_image.background_sgv.value
        ? this.setting_image.background_sgv.value
        : '/img/backgrounds/farm-1.jpg';
    },
    getLogo() {
      if (this.loadingImage) return '';

      return this.setting_image && this.setting_image.logo_sgv && this.setting_image.logo_sgv.value
        ? this.setting_image.logo_sgv.value
        : '/img/brand/top-logo.png';
    }
  },
  mounted() {
    this.initScrollbar();
    this.initSidebarItems();
  },
  watch: {
    'setting_image': {
      handler(newValue) {
        setTimeout(() => {
          this.loadingImage = false;
        }, 500);
      },
      deep: true,
      immediate: true
    }
  },
};
</script>

<style lang="scss">

html {
  background-color: #fff;
}

.navbar.sidenav{
  overflow: hidden;

  &:hover {
    overflow-y: auto;
  }
}

@media (max-width: 768px) {
  .sideBar {
    background-color: black;
  }
  .route-mobile-rm{
    display: none;
    pointer-events: none;
    opacity: 0; 
  }
}
</style>
